// extracted by mini-css-extract-plugin
module.exports = {"root":"Errors_root__2UfrN","errors":"Errors_errors__1Om-H"};